import React, { useEffect, useState } from "react";
import { AuthData, BindData } from "../lib/type";
import { clearCacheAndBuildToken } from "../lib";

type ContextData = {
  auth?: AuthData;
  bindData?: BindData;
};

type ContextType = ContextData & {
  setAuth: (data?: AuthData | undefined) => void;
  setBindData: (data: BindData) => void;
};

const context = React.createContext<ContextType>({} as ContextType);
type Props = { children: React.ReactNode };

export default function DataContextProvider({ children }: Props) {
  const [auth, setAuth] = useState<AuthData | undefined>();
  const [bindData, setBindData] = useState<BindData | undefined>();

  useEffect(() => {
    clearCacheAndBuildToken();
  }, []);

  return (
    <context.Provider
      value={{
        bindData,
        auth,
        setAuth: (data?: AuthData | undefined) => setAuth(data),
        setBindData: (data?: BindData) => setBindData(data),
      }}
    >
      {children}
    </context.Provider>
  );
}

export const useDataContext = () => React.useContext(context);
